import { Button as ANTButton, Skeleton, Empty, Switch, Form, notification, Popconfirm } from 'antd';
import DynamicDrawer from 'components/drawer';
import React, { useEffect, useState } from 'react';
import Select from 'components/Atom/Select';
import { PageHeader } from '../../../components/Atom/PageHeader';
import Input from 'components/Atom/Input';
import { EditFilled } from '@ant-design/icons';
import { Button } from 'components/Atom/Button';
import { USER_ROLES } from 'utils/constant';
import { useSelector } from 'react-redux';
import { Breadcrumbs } from '../../../components/Atom/breadcumbs';
import { checkUserPermissions } from 'utils/services';
import SelectStore from 'components/SelectStore';
import { useQuery, useQueryClient } from 'react-query';
import http from 'utils/http';

export const PaymentChannels = () => {
  const queryClient = useQueryClient();
  const [isPaymentChannelModalOpen, setIsPaymentChannelModalOpen] = useState(false);
  const [isPaymentChannelFormOpen, setIsPaymentChannelFormOpen] = useState(false);
  const [store, setStore] = useState(useSelector((state) => state.company.store));
  const [paymentChannelType, setPaymentChannelType] = useState(null);
  const [isChannelDeleting, setIsChannelDeleting] = useState(false);
  const [isChannelUpdating, setIsChannelUpdating] = useState(false);
  const [statusToggle, setStatusToggle] = useState(true);
  const getStore = async () => {
    const res = await http.get(`/stores/${store?._id}`);
    return res?.data?.data;
  };
  const { data, refetch, isLoading } = useQuery('paymentChannels', getStore, {
    enabled: false,
    manual: true,
    initialData: store,
  });

  useEffect(() => {
    refetch();
  }, [store]);
  const onUpdateSubmit = async (data) => {
    setIsChannelUpdating(true);
    try {
      let payload;
      if (paymentChannelType === 'nift') {
        const { merchant_name, merchant_id, password } = data;
        payload = {
          niftGateway: {
            merchant_name,
            merchant_id,
            password,
          },
          enableNift: statusToggle,
        };
        const response = await http.post(`/stores/update/nift/${store._id}`, payload);
        queryClient.setQueryData('paymentChannels', response?.data?.data);
        notification.success({ message: 'DATA ADDED SUCCESSFULLY', placement: 'bottomRight' });
        handleCloseModal();
      }
    } catch (err) {
      console.log(JSON.stringify(err));
      notification.error({ message: 'DATA NOT UPDATE', placement: 'bottomRight' });
    }
    setIsChannelUpdating(false);
  };
  const onDeleteSubmit = async () => {
    setIsChannelDeleting(true);
    try {
      if (paymentChannelType === 'nift') {
        const response = await http.delete(`/stores/delete/nift/${store._id}`);
        queryClient.setQueryData('paymentChannels', response?.data?.data);
        notification.success({ message: 'CHANNEL DELETED SUCCESSFULLY', placement: 'bottomRight' });
        handleCloseModal();
      }
    } catch (err) {
      console.log(JSON.stringify(err));
      notification.error({ message: 'DATA NOT DELETED', placement: 'bottomRight' });
    }
    setIsChannelDeleting(false);
  };

  const handleEditModel = (type, status) => {
    setPaymentChannelType(type);
    setIsPaymentChannelModalOpen(true);
    if (type === 'nift') {
      setStatusToggle(store?.enableNift);
    }
  };
  const options = [
    {
      label: 'Select Channel',
      value: 'none',
    },
    ...(!store?.niftGateway?.merchant_name
      ? [
          {
            label: 'NIFT',
            value: 'nift',
          },
        ]
      : []),
  ];
  const handleOnStoreChange = (e) => {
    setStore(e);
  };
  const handleCloseModal = () => {
    setPaymentChannelType(null);
    setIsPaymentChannelModalOpen(false);
    setIsPaymentChannelFormOpen(false);
  };
  const niftInitialsValues = {
    merchant_name: data?.niftGateway?.merchant_name ?? '',
    merchant_id: data?.niftGateway?.merchant_id ?? '',
    password: data?.niftGateway?.password ?? '',
  };
  const niftChannelData = [
    {
      title: 'Merchant Name',
      value: data?.niftGateway?.merchant_name ?? '',
    },
    {
      title: 'Merchant Id',
      value: data?.niftGateway?.merchant_id ?? '',
    },
    {
      title: 'Channel Status',
      value: data?.enableNift ? 'Enabled' : 'Disabled',
    },
    {
      title: 'Merchant Password',
      value: data?.niftGateway?.password
        ? [...Array(40)].map((e, i) => (
            <span className='text-lg' key={i}>
              &#x2022;
            </span>
          ))
        : 'No found',
    },
  ];
  const breadcrumbProps = {
    breadcrumbs: [
      {
        name: 'Home',
        href: '/xpay',
      },
      {
        name: 'Settings',
      },
      {
        name: 'Payment Channels',
      },
    ],
  };
  return (
    <div style={{ padding: '0px', width: '100%' }}>
      <div style={{ marginTop: '10px' }}>
        <Breadcrumbs {...breadcrumbProps} />
      </div>
      <div className='headerPage'>
        <div className='child'>
          <PageHeader label={'Payment Channels'} />
        </div>
        <div className='flexStoreFields m-r-10'>
          <SelectStore onChange={handleOnStoreChange} setDefault={true} />
          {checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN]) && (
            <Button id='removeBtn' onClick={() => setIsPaymentChannelFormOpen(true)}>
              Add Channel
            </Button>
          )}
        </div>
      </div>
      <br />
      <div className='overflow-x-auto'>
        <div className='bg-white shadow ' style={{ width: '100%' }}>
          {isLoading ? (
            <div style={{ width: '100%' }}>
              <Skeleton.Input style={{ width: '100%', height: '860px' }} active={true} />
            </div>
          ) : data?.niftGateway?.merchant_name ? (
            <div>
              <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6' style={{ marginBottom: '-18px', display: 'flex' }}>
                <h1 className='font-bold text-[15px]'>NIFT Payment Channel</h1>
                {checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN]) && (
                  <span className='flex items-center cursor-pointer' onClick={() => handleEditModel('nift')}>
                    <EditFilled
                      className='text-[18px]'
                      style={{
                        color: '#172b4d',
                      }}
                    />
                  </span>
                )}
              </div>
              {niftChannelData.map((obj, index) => {
                return (
                  <div className='bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6' key={index}>
                    <dt className='text-sm font-medium text-gray-500'>{obj?.title}</dt>
                    <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 overflow-hidden'>{obj?.value}</dd>
                  </div>
                );
              })}
            </div>
          ) : (
            <Empty style={{ padding: '50px' }} description={'Payment channel not found'}></Empty>
          )}
        </div>
      </div>
      <DynamicDrawer
        title={!isPaymentChannelFormOpen ? 'Edit Channel Details' : 'Add Payment Channel'}
        open={isPaymentChannelModalOpen || isPaymentChannelFormOpen}
        handleClose={() => {
          handleCloseModal();
        }}>
        <EditPaymentChannelForm
          options={options}
          initialValues={isPaymentChannelFormOpen ? null : niftInitialsValues}
          onSubmit={onUpdateSubmit}
          handleCloseModal={handleCloseModal}
          setChannelType={setPaymentChannelType}
          paymentChannelType={paymentChannelType}
          statusToggle={statusToggle}
          onDeleteChannel={onDeleteSubmit}
          setStatusToggle={setStatusToggle}
          isChannelDeleting={isChannelDeleting}
          isChannelUpdating={isChannelUpdating}
        />
      </DynamicDrawer>
    </div>
  );
};
const EditPaymentChannelForm = ({
  onDeleteChannel,
  isChannelDeleting,
  handleCloseModal,
  paymentChannelType,
  options,
  statusToggle,
  setStatusToggle,
  onSubmit,
  setChannelType,
  isChannelUpdating,
  initialValues,
}) => {
  return (
    <Form layout='vertical' onFinish={onSubmit} initialValues={initialValues}>
      {!initialValues && (
        <Form.Item className='font-bold mb-[30px]' label='Payment Channel Type'>
          <Select defaultValue={paymentChannelType} optionsValue={options} handleChange={(e) => setChannelType(e.value)} />
        </Form.Item>
      )}
      {paymentChannelType === 'nift' && (
        <>
          <Form.Item
            name='merchant_name'
            label='Merchant Name:'
            rules={[
              {
                required: true,
                message: 'Merchant Name required',
              },
            ]}>
            <Input placeholder='Enter merchant name' name='merchant_name' />
          </Form.Item>
          <Form.Item
            name='merchant_id'
            label='Merchant Id:'
            rules={[
              {
                required: true,
                message: 'Merchant id is required',
              },
            ]}>
            <Input placeholder='Enter merchant id' name='merchant_id' />
          </Form.Item>
          <Form.Item
            name='password'
            label='Merchant Password:'
            rules={[
              {
                required: true,
                message: 'Password is required',
              },
            ]}>
            <Input type='password' placeholder='Enter merchant password' name='password' />
          </Form.Item>
          <div className='flex items-center justify-between'>
            <div className=''>
              <Form.Item name='channel_status' className='font-bold mb-[30px]' label='Channel Status'>
                <Switch checked={statusToggle} onClick={() => setStatusToggle(!statusToggle)} name='channel_status' />
              </Form.Item>
            </div>
          </div>
        </>
      )}
      {paymentChannelType !== 'none' && paymentChannelType !== null && (
        <div className='mt-[30px]'>
          <Form.Item>
            <div className='binClass'>
              <div>
                <ANTButton onClick={() => handleCloseModal()} className='mr-[10px]'>
                  Cancel
                </ANTButton>
                <Button type='primary' htmlType='submit' loading={isChannelUpdating}>
                  {initialValues ? 'Update' : 'Submit'}
                </Button>
              </div>
              {initialValues && (
                <Popconfirm
                  title={'Are you sure you want to delete this Channel'}
                  okButtonProps={{ loading: isChannelDeleting }}
                  onConfirm={onDeleteChannel}
                  okText='Yes'
                  cancelText='No'
                  placement='topRight'
                  getPopupContainer={(trigger) => trigger.parentNode}>
                  <Button type='primary'>{'Delete'}</Button>
                </Popconfirm>
              )}
            </div>
          </Form.Item>
        </div>
      )}
    </Form>
  );
};
